const colorsFile = [
    {
        id: '1',
        name: 'red',
        color: '#f00'
    },
    {
        id: '2',
        name: 'green',
        color: '#0f0'
    },
    {
        id: '3',
        name: 'blue',
        color: '#00f'
    }
]

export default colorsFile;